<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 1080.0487 748.00219"
  >
    <defs />
    <path
      class="fill-current text-primary"
      d="M772.23194 511.46931c0 67.693-40.24241 91.32887-89.88394 91.32887s-89.88394-23.63587-89.88394-91.32887S682.348 357.66015 682.348 357.66015s89.88394 86.11617 89.88394 153.80916z"
    />
    <path
      fill="#3f3d56"
      d="M679.994 535.79l38.311-70.088-38.167 61.201.414-25.473 26.404-50.708-26.294 43.966.744-45.815 28.274-40.369-28.157 33.165.465-84.009-2.797 106.449-28.631-43.825 28.285 52.808-2.679 51.167-.079-1.358-33.139-46.304 33.038 51.102-.335 6.399-.06.097.028.525-6.796 68.28h9.079l1.09-5.516 32.957-50.977-32.875 45.936.92-56.653z"
    />
    <path
      fill="#f2f2f2"
      d="M1080.0487 293.81378c0 129.31047-76.873 174.46085-171.7007 174.46085s-171.7007-45.15038-171.7007-174.46085S908.348 0 908.348 0s171.7007 164.50331 171.7007 293.81378z"
    />
    <path
      fill="#3f3d56"
      d="M902.093 448.494l1.758-108.221 73.184-133.885-72.908 116.908.791-48.661 50.437-96.864-50.228 83.987v.001l1.422-87.519 54.009-77.116-53.786 63.354L907.661 0l-5.583 212.444.459-8.764-54.912-84.052 54.031 100.875-5.116 97.743-.153-2.594-63.303-88.452 63.112 97.617-.64 12.224-.115.184.053 1.003-12.981 247.982h17.343l2.081-128.087 62.957-97.378-62.801 87.749z"
    />
    <path
      fill="#3f3d56"
      d="M1073 564.55849c0 38.59549-250.36912 183.44369-543.05156 183.44369S0 673.03729 0 634.4418s231.44239 7.27952 524.12483 7.27952S1073 525.96301 1073 564.55849z"
    />
    <path
      d="M1073 564.55849c0 38.59549-250.36912 183.44369-543.05156 183.44369S0 673.03729 0 634.4418s231.44239 7.27952 524.12483 7.27952S1073 525.96301 1073 564.55849z"
      opacity=".1"
    />
    <path
      fill="#3f3d56"
      d="M1073 564.55849c0 38.59549-250.36912 139.76663-543.05156 139.76663S0 673.03729 0 634.4418s231.44235-36.39755 524.12483-36.39755S1073 525.96301 1073 564.55849z"
    />
    <ellipse
      cx="535.87833"
      cy="641.77394"
      opacity=".1"
      rx="225.04403"
      ry="17.40672"
    />
    <path
      fill="#a0616a"
      d="M357.59802 292.96566s65.88345 1.22006 53.68281 12.81067-57.953 0-57.953 0z"
    />
    <path
      class="fill-current text-primary"
      d="M220.3285 152.18292s26.60021-4.75031 35.84921 16.72359 28.244 82.71589 28.244 82.71589 50.83308 33.64785 60.079 32.54232 25.05178 1.15023 22.15247 11.2372-1.6122 21.52484-8.28694 22.92668-17.29058-11.97954-25.415-5.53421-80.53015-17.09648-85.17856-21.97431-43.27878-110.50134-43.27878-110.50134 1.54524-28.47996 15.8346-28.13582z"
    />
    <path
      fill="#a0616a"
      d="M277.379 605.607l3.05 25.621-25.621 6.711-14.641-6.711v-22.571l37.212-3.05zM208.445 622.078l3.05 25.621-25.621 6.711-14.641-6.711v-22.571l37.212-3.05z"
    />
    <path
      fill="#2f2e41"
      d="M279.81895 325.60237l11.59061 42.0922 17.08089 85.40452s4.88026 20.74108-4.88025 45.75239-27.45144 106.75554-23.79125 111.63579-41.48217 8.54045-40.87214 3.66019 6.71036-71.98376 6.71036-71.98376 8.54044-59.1731 12.81067-66.49348-19.521-25.62134-19.521-25.62134-6.10031 70.15367-15.25079 76.254-7.93045 100.65521-12.2007 101.87532-35.38185 6.10032-39.042 0 0-107.97565 0-107.97565 20.74108-77.47406 16.47086-88.45463-1.8301-57.953-1.8301-57.953-15.86083-35.99189-7.32038-54.90287z"
    />
    <path
      fill="#a0616a"
      d="M277.98886 91.35009s-25.62134 31.72166-24.40128 45.75239-40.26211-25.62134-40.26211-25.62134 29.89157-40.2621 29.89157-48.80255 34.77182 28.6715 34.77182 28.6715z"
    />
    <circle
      cx="277.68384"
      cy="62.98363"
      r="40.26211"
      fill="#a0616a"
    />
    <path
      class="fill-current text-primary"
      d="M176.21719 302.78109c-1.824 6.79577-4.08719 14.50047-3.76385 20.99122.20746 4.20313 11.36489 6.96045 26.79255 8.76616 14.30529 1.67758 32.283 2.53161 48.62569 2.97085 17.16021.46363 32.50245.46363 39.87779.46363 21.96115 0 4.27022-14.03074-4.27023-20.74109s-6.71035-101.87533-6.10031-114.076-5.49029-47.58249-5.49029-54.29285-14.35407-24.22438-14.35407-24.22438-3.33686 9.58362-16.75756-3.227-31.11163-16.47086-31.11163-16.47086c-13.4207 4.88025-35.99188 58.56306-37.21194 67.71354-.49417 3.71507-.08542 22.742.74422 44.46523 1.20174 31.75216 3.30029 69.2874 4.74606 73.27093 1.14073 3.14162-.12197 8.41228-1.72643 14.39062z"
    />
    <path
      fill="#a0616a"
      d="M241.387 338.413l4.27 15.251-16.471 17.081-5.49-23.792 17.691-8.54z"
    />
    <path
      fill="#2f2e41"
      d="M246.87723 624.51801s12.81067 14.64076 22.57118 4.88025 9.15048-15.86083 10.98058-15.86083 29.28153 24.40128 29.28153 24.40128 46.97245 10.98057 21.35111 18.911-98.21513 2.44013-98.21513 0-1.8301-34.77182 4.88025-34.77182z"
    />
    <path
      fill="#2f2e41"
      d="M177.94362 640.98887s12.81067 14.64076 22.57118 4.88025 9.15048-15.86083 10.98058-15.86083 29.28153 24.40128 29.28153 24.40128 46.97246 10.98057 21.35112 18.911-98.21514 2.44013-98.21514 0-1.8301-34.77182 4.88025-34.77182zM232.48068 95.12287c-1.30065.84028-2.99385 1.69175-4.29617.85407a194.661 194.661 0 01-10.803-37.40333c-.82225-4.49515-1.393-9.49233 1.10424-13.3194.9849-1.50939 2.40274-2.74371 3.12416-4.39532 1.09254-2.50124.37345-5.39643.73641-8.10163.76042-5.66737 6.11775-9.62022 11.505-11.5373s11.23835-2.51176 16.37345-5.02733c4.87591-2.38861 8.78111-6.35 13.3025-9.35611s10.31287-5.0615 15.34812-3.03018c4.45436 1.797 7.229 6.33734 11.43921 8.64913 2.8571 1.5688 6.17272 2.00534 9.36187 2.67875a59.9218 59.9218 0 0124.33972 11.30812 17.67252 17.67252 0 014.42964 4.56639c5.40289 8.8953-4.27062 20.98885-.00283 30.48113l-9.22662-7.28052a32.13074 32.13074 0 00-8.24035-5.237c-3.05623-1.15765-6.67559-1.29745-9.45179.42692-3.89609 2.42-4.95269 7.47582-6.3137 11.8557s-4.3705 9.23676-8.95561 9.12455c-6.23545-.15259-8.41611-8.85468-14.012-11.60979-3.6479-1.796-8.23962-.61324-11.34953 2.00618-3.10968 2.61923-4.97572 6.41973-6.34429 10.24826-.85526 2.39254-1.65774 5.08957-3.1768 7.16346-1.6754 2.28735-3.81829 2.47136-5.60773 4.17946-4.65798 4.44627-7.52185 9.03322-13.2839 12.75579z"
    />
    <path
      d="M176.21719 302.78109c7.58272 10.99889 16.12928 22.34547 23.0287 29.75738 14.30529 1.67758 32.283 2.53161 48.62569 2.97085a38.52679 38.52679 0 00-10.75486-9.90691c-7.93037-4.88032-26.84137-62.83332-26.84137-62.83332s23.18122-59.78313 29.28154-82.35431-17.69093-35.38185-17.69093-35.38185c-10.98061-9.15049-29.89161 12.20063-29.89161 12.20063s-9.65075 29.1107-18.7768 57.88593c1.20174 31.75216 3.30029 69.2874 4.74606 73.27093 1.14074 3.14167-.12196 8.41233-1.72642 14.39067z"
      opacity=".1"
    />
    <path
      class="fill-current text-primary"
      d="M220.03583 140.15266s23.79124 12.81067 17.69092 35.38185-29.28153 82.35431-29.28153 82.35431 18.911 57.953 26.8414 62.83329 18.911 16.47086 10.37055 22.57118-14.64077 15.86083-20.74109 12.81067-6.10032-20.13105-16.47086-20.13105-52.46275-63.44332-53.07278-70.15367 34.77182-113.46594 34.77182-113.46594 18.91099-21.35112 29.89157-12.20064z"
    />
    <path
      fill="#ff6584"
      d="M714.74585 306.89204l-6.8628-6.86279a21.34485 21.34485 0 00-30.18617 0L544.58169 433.14444 411.4665 300.02925a21.34485 21.34485 0 00-30.18617 0l-6.86279 6.86279a21.34484 21.34484 0 000 30.18618l133.11518 133.11519-133.11518 133.11518a21.34484 21.34484 0 000 30.18618l6.86279 6.86279a21.34485 21.34485 0 0030.18617 0l133.11519-133.11519 133.11519 133.11519a21.34485 21.34485 0 0030.18617 0l6.8628-6.86279a21.34486 21.34486 0 000-30.18618L581.63066 470.19341l133.11519-133.11519a21.34486 21.34486 0 000-30.18618z"
    />
    <path
      d="M369.66705 610.54572L498.8294 481.38344l-1.24334-1.24334-123.16854 123.16847a21.2598 21.2598 0 00-4.75047 7.23715zM372.57695 311.21927a21.34488 21.34488 0 0130.18621 0l133.11519 133.11517L668.9935 311.21927a21.34488 21.34488 0 0130.18621 0l6.86279 6.86279a21.34354 21.34354 0 014.75047 22.949l3.95289-3.95289a21.34479 21.34479 0 000-30.18614l-6.86279-6.86279a21.3449 21.3449 0 00-30.18621 0L544.58169 433.1444 411.46652 300.02923a21.3449 21.3449 0 00-30.18621 0l-6.86279 6.86279a21.2598 21.2598 0 00-4.75047 7.23715zM582.87403 471.43674l-9.94669 9.9467L706.0425 614.49861a21.34356 21.34356 0 014.75047 22.94907l3.95289-3.953a21.34479 21.34479 0 000-30.18614z"
      opacity=".1"
    />
    <path
      class="fill-current text-primary"
      d="M155 560.19238c0 56.22159-33.42284 75.85206-74.652 75.85206S5.696 616.41397 5.696 560.19238s74.652-127.7443 74.652-127.7443S155 503.9708 155 560.19238z"
    />
    <path
      fill="#3f3d56"
      d="M78.393 580.392l31.819-58.211-31.699 50.83.344-21.157 21.929-42.115-21.838 36.516.618-38.051 23.482-33.529-23.385 27.546.386-69.773-2.323 88.41-23.779-36.398 23.491 43.858-2.224 42.497-.066-1.128-27.523-38.457 27.439 42.442-.278 5.315-.05.08.023.436-5.644 56.709h7.541l.905-4.581 27.372-42.338-27.304 38.151.764-47.052z"
    />
  </svg>
</template>
